/* WFW-008-AB */
(function () {
  function entryFromButton(btn) {
    var tpl = btn.querySelector('template[data-bestsellers-rating-template]');
    var src = btn.getAttribute('data-img-src');
    var priceHtml = btn.getAttribute('data-price-html');
    var title = btn.getAttribute('data-title-text');
    if (!tpl && !src && !priceHtml && !title) return null;

    return {
      imgSrc: src || '',
      imgSrcset: btn.getAttribute('data-img-srcset') || '',
      priceHtml: priceHtml || '',
      title: title || '',
      url: btn.getAttribute('data-pdp-url') || '',
      reviewsMobileText: btn.getAttribute('data-reviews-mobile-text') || '',
      reviewsAriaLabel: btn.getAttribute('data-reviews-aria-label') || '',
      ratingHtml: tpl ? tpl.innerHTML : '',
    };
  }

  function applySwatch(root, btn, img, priceEl) {
    var entry = entryFromButton(btn);

    if (entry) {
      if (entry.imgSrc && img) {
        img.src = entry.imgSrc;
        if (entry.imgSrcset) {
          img.srcset = entry.imgSrcset;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-sizes');
        }
        img.classList.remove('lazyload');
        if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
          window.lazySizes.loader.unveil(img);
        }
      }
      if (entry.priceHtml && priceEl) priceEl.innerHTML = entry.priceHtml;

      var titleEl = root.querySelector('[data-bestsellers-card-title]');
      if (titleEl && entry.title) titleEl.textContent = entry.title;

      var ratingWrap = root.querySelector('[data-bestsellers-rating-wrap]');
      if (ratingWrap && entry.ratingHtml) ratingWrap.innerHTML = entry.ratingHtml;

      var mobileCount = root.querySelector('[data-bestsellers-reviews-mobile]');
      if (mobileCount && entry.reviewsMobileText) mobileCount.textContent = entry.reviewsMobileText;

      if (entry.url) {
        root.querySelectorAll('[data-bestsellers-pdp-link]').forEach(function (a) {
          a.href = entry.url;
        });
      }

      var imgLink = root.querySelector('.bestsellers-consolidated-card__image-link[data-bestsellers-pdp-link]');
      if (imgLink && entry.title) imgLink.setAttribute('aria-label', entry.title);

      var reviewsLink = root.querySelector('.bestsellers-consolidated-card__reviews-link[data-bestsellers-pdp-link]');
      if (reviewsLink && entry.reviewsAriaLabel) reviewsLink.setAttribute('aria-label', entry.reviewsAriaLabel);
    }

    root.querySelectorAll('[data-bestsellers-swatch]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.classList.toggle('selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function bindCarouselDots(section) {
    if (section.getAttribute('data-bestsellers-carousel-dots-bound') === 'true') return;

    var carousel = section.querySelector('[data-bestsellers-carousel]');
    var sliderGrid = carousel && carousel.querySelector('slider-grid');
    var track = sliderGrid && sliderGrid.querySelector('[slider-grid-track]');
    var dotsWrap =
      carousel &&
      (carousel.querySelector('[data-bestsellers-carousel-dots]') ||
        carousel.querySelector('.bestsellers-consolidated__carousel-dots'));

    if (!carousel || !sliderGrid || !track || !dotsWrap) return;

    var slides = Array.prototype.slice.call(sliderGrid.querySelectorAll('[slider-grid-slide]'));
    if (!slides.length) return;

    section.setAttribute('data-bestsellers-carousel-dots-bound', 'true');

    var mobileQuery = window.matchMedia('(max-width: 767px)');
    var syncFrame = null;

    function getDots() {
      return Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-bestsellers-carousel-dot]'));
    }

    function setActiveDot(activePos) {
      getDots().forEach(function (dot) {
        var dotPos = parseInt(dot.getAttribute('data-index') || '0', 10);
        var on = dotPos === activePos;
        dot.classList.toggle('is-primary', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function getScrollLeftToCenter(slide) {
      var slideLeft = slide.offsetLeft;
      var slideWidth = slide.offsetWidth;
      var trackWidth = track.clientWidth;
      var targetLeft = slideLeft - (trackWidth - slideWidth) / 2;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (targetLeft < 0) targetLeft = 0;
      if (targetLeft > maxScroll) targetLeft = maxScroll;
      return targetLeft;
    }

    function getActiveSlidePos() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var activePos = 0;
      var minDistance = Infinity;

      slides.forEach(function (slide, i) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var distance = Math.abs(slideCenter - trackCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activePos = i;
        }
      });

      return activePos;
    }

    function scrollToSlidePos(slidePos) {
      var slide = slides[slidePos];
      if (!slide) return;

      if (typeof slide.scrollIntoView === 'function') {
        slide.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
        return;
      }

      track.scrollTo({ left: getScrollLeftToCenter(slide), behavior: 'smooth' });
    }

    function forceStartState() {
      var firstSlide = slides[0];
      if (firstSlide) {
        track.scrollLeft = getScrollLeftToCenter(firstSlide);
      } else {
        track.scrollLeft = 0;
      }
      setActiveDot(0);
    }

    function syncDots() {
      if (!mobileQuery.matches) return;
      setActiveDot(getActiveSlidePos());
    }

    function scheduleSync() {
      if (syncFrame) cancelAnimationFrame(syncFrame);
      syncFrame = requestAnimationFrame(syncDots);
    }

    track.addEventListener('scroll', scheduleSync, { passive: true });
    track.addEventListener('touchend', function () {
      window.setTimeout(syncDots, 80);
      window.setTimeout(syncDots, 320);
    }, { passive: true });

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', syncDots, { passive: true });
    }

    dotsWrap.addEventListener('click', function (event) {
      if (!mobileQuery.matches) return;

      var dot = event.target.closest('[data-bestsellers-carousel-dot]');
      if (!dot) return;

      event.preventDefault();

      var targetPos = parseInt(dot.getAttribute('data-index') || '0', 10);
      if (targetPos < 0 || targetPos >= slides.length) return;

      setActiveDot(targetPos);
      scrollToSlidePos(targetPos);

      window.setTimeout(syncDots, 50);
      window.setTimeout(syncDots, 200);
      window.setTimeout(syncDots, 450);
    });

    mobileQuery.addEventListener('change', function () {
      if (mobileQuery.matches) forceStartState();
      else scheduleSync();
    });

    forceStartState();
    window.setTimeout(forceStartState, 0);
    window.setTimeout(forceStartState, 150);
    window.setTimeout(forceStartState, 400);
    window.addEventListener('load', forceStartState, { once: true });
  }

  function initCarouselDots(scope) {
    var container = scope || document;
    var sections;

    if (container.classList && container.classList.contains('bestsellers-consolidated--var-1')) {
      sections = [container];
    } else if (container.querySelectorAll) {
      sections = container.querySelectorAll('.bestsellers-consolidated--var-1');
    } else {
      sections = [];
    }

    Array.prototype.forEach.call(sections, function (section) {
      function tryBind() {
        bindCarouselDots(section);
      }

      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined('slider-grid').then(tryBind).catch(tryBind);
      }

      tryBind();
      window.setTimeout(tryBind, 250);
      window.setTimeout(tryBind, 800);
    });
  }

  function init(scope) {
    var container = scope || document;
    var roots = container.querySelectorAll('.bestsellers-consolidated--var-1 [data-bestsellers-consolidated]');
    roots.forEach(function (root) {
      if (root.getAttribute('data-bestsellers-v1-bound') === 'true') return;
      root.setAttribute('data-bestsellers-v1-bound', 'true');

      var img = root.querySelector('[data-bestsellers-main-img]');
      var priceEl = root.querySelector('[data-bestsellers-price]');
      if (!priceEl) return;

      root.querySelectorAll('[data-bestsellers-swatch]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          applySwatch(root, btn, img, priceEl);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initCarouselDots(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    initCarouselDots(e.target);
  });
})();
